// Builds a themed token set from the tenant's own brand colors, layered on top
// of a fallback preset. Sidebar/navigation tokens and admin-role tokens
// (avatarBg/avatarCol) are intentionally left from the fallback — brand
// colors take over the topbar, decorative left panel, and accent only.
export function getBrandTheme(branding, fallback) {
  if (!branding?.primaryColor) return fallback;
  const primary = branding.primaryColor;
  const accent = branding.secondaryColor || primary;
  return {
    ...fallback,
    lp: primary,
    tb: primary,
    tbt: "#ffffff",
    tbb: "rgba(255,255,255,0.12)",
    tbst: "rgba(255,255,255,0.62)",
    pri: accent,
  };
}
